import { GetterTree } from 'vuex'
import {
  NotificationsState,
  LoginViewNotification,
  InternalMessage
} from '@/store/modules/notifications/notificationsTypes'
import { RootState } from '@/store/types/storeGlobalTypes'

export const getters: GetterTree<NotificationsState, RootState> = {
  getLoginViewNotification(state): LoginViewNotification | {} {
    return state.loginViewNotification
  },
  getInternalMessages(state): InternalMessage[] {
    return state.internalMessages
  },
  getContextInternalMessages(state): any[] {
    return state.contextInternalMessages
  }
}
